'use strict';

var _ = require('lodash');
var StrategyRecordService = function StrategyRecordService(conditionsAndActionsService, StrategyConstants) {
  function getLevelData(type, level, entityType, flowType) {
    if (type === StrategyConstants.ACTION) {
      return conditionsAndActionsService.getActionByDomain(level, entityType);
    } else {
      return conditionsAndActionsService.getConditionByDomain(level, entityType, flowType);
    }
  }
  function getCacheKey(type, level, entityType, flowType) {
    return type + '-' + level + '-' + entityType + '-' + flowType;
  }
  var getContext = _.memoize(function (type, level, entityType, flowType) {
    var context = {
      categories: {},
      metaCategories: {},
      fields: {},
      constraints: {},
      argsNo: {},
      availableValues: {},
      patterns: {},
      criteriaType: {},
      flowTypeField: {},
      precisions: {},
      isFieldValueRequireds: {}
    };
    var levelData = getLevelData(type, level, entityType, flowType);
    if (levelData) {
      context.valid = true;
      levelData.categories.forEach(function (category) {
        var mappedCategory = {};
        var mappedFields = {};
        var mappedMetaCategories = {};
        var mappedConstraints = {};
        var mappedOptionToArgsNo = {};
        var mappedOptionToPrecision = {};
        var mappedOptionToAvailableValues = {};
        var mappedOptionToPatterns = {};
        var mappedOptionToCriteriaType = {};
        var mappedOptionToFlowTypeField = {};
        category.criteria.forEach(function (criterion) {
          var mappedCriterion = {};
          var mappedArgsNo = {};
          var mappedAvailableValues = {};
          var mappedPatterns = {};
          var mappedPrecisions = {};
          if (type === StrategyConstants.ACTION) {
            criterion.actions.forEach(function (action) {
              var key = action.option;
              mappedCriterion[key] = action.valueType;
              mappedArgsNo[key] = action.argsNo ? action.argsNo : '1';
              mappedPatterns[key] = action.pattern;
              mappedAvailableValues[key] = action.availableValues ? StrategyConstants.DROP_DOWN_DATA[action.availableValues] : undefined;
            });
          } else {
            criterion.operators.forEach(function (operator) {
              var key = operator.operator;
              mappedCriterion[key] = operator.valueType;
              mappedPrecisions[key] = operator.precision ? operator.precision : undefined;
              mappedArgsNo[key] = operator.argsNo ? operator.argsNo : '1';
              mappedPatterns[key] = operator.pattern;
              mappedAvailableValues[key] = operator.availableValues ? StrategyConstants.DROP_DOWN_DATA[operator.availableValues] : undefined;
            });
          }
          var criteriaName = criterion.criteriaName;
          mappedCategory[criteriaName] = mappedCriterion;
          mappedOptionToPrecision[criteriaName] = mappedPrecisions;
          mappedFields[criteriaName] = criterion.field;
          mappedMetaCategories[criteriaName] = criterion.metaCategory;
          mappedConstraints[criteriaName] = criterion.constraint;
          mappedOptionToArgsNo[criteriaName] = mappedArgsNo;
          mappedOptionToAvailableValues[criteriaName] = mappedAvailableValues;
          mappedOptionToPatterns[criteriaName] = mappedPatterns;
          mappedOptionToCriteriaType[criteriaName] = criterion.criteriaType;
          mappedOptionToFlowTypeField[criteriaName] = criterion.flowTypeField;
        });
        var categoryName = category.categoryName;
        context.categories[categoryName] = mappedCategory;
        context.fields[categoryName] = mappedFields;
        context.metaCategories[categoryName] = mappedMetaCategories;
        context.precisions[categoryName] = mappedOptionToPrecision;
        context.constraints[categoryName] = mappedConstraints;
        context.argsNo[categoryName] = mappedOptionToArgsNo;
        context.availableValues[category.categoryName] = mappedOptionToAvailableValues;
        context.patterns[category.categoryName] = mappedOptionToPatterns;
        context.isFieldValueRequireds[category.categoryName] = !_.isUndefined(category.isFieldValueRequired) ? category.isFieldValueRequired : true;
        if (!_.isEmpty(mappedOptionToCriteriaType)) {
          context.criteriaType[categoryName] = mappedOptionToCriteriaType;
        }
        if (!_.isEmpty(mappedOptionToFlowTypeField)) {
          context.flowTypeField[categoryName] = mappedOptionToFlowTypeField;
        }
      });
    } else {
      throw new Error('Invalid Context. Unable to read context data for type=' + type + ', level=' + level + ', entityType=' + entityType + ', flowType=' + flowType);
    }
    return context;
  }, getCacheKey);
  function getCategories(type, level, entityType, flowType) {
    var context = getContext(type, level, entityType, flowType);
    return Object.keys(context.categories);
  }
  function getCriteria(type, level, entityType, flowType, category) {
    if (!category || !level) {
      return null;
    }
    var context = getContext(type, level, entityType, flowType);
    return context.categories[category] ? Object.keys(context.categories[category]) : null;
  }
  function getDefaultCriteriaTypeValue(context, category, criteria, operator) {
    return context.availableValues[category][criteria][operator][0];
  }
  function getValueForCriteriaType(type, level, entityType, category, criteria) {
    if (!category || !criteria || !level) {
      return null;
    }
    var context = getContext(type, level, entityType);
    if (context.criteriaType[category][criteria]) {
      return context.criteriaType[category][criteria].fieldValue || getDefaultCriteriaTypeValue(context, category, criteria, 'Set');
    } else {
      return null;
    }
  }
  function getCriteriaKeys(context, category, criteria) {
    if (context && context.categories[category] && context.categories[category][criteria]) {
      return Object.keys(context.categories[category][criteria]);
    }
    return null;
  }
  function getOptions(type, level, entityType, category, criteria) {
    if (!category || !criteria || !level) {
      return null;
    }
    var context = getContext(type, level, entityType);
    return getCriteriaKeys(context, category, criteria);
  }
  function getContextPropertyValue(contextProperty, type, level, entityType, category, criteria) {
    if (!category || !criteria || !level || !type || !entityType) {
      return null;
    }
    var context = getContext(type, level, entityType);
    if (context[contextProperty][category]) {
      return context[contextProperty][category][criteria];
    } else {
      return null;
    }
  }
  function getConnectedFields(type, level, entityType, category, criteria) {
    return getContextPropertyValue('fields', type, level, entityType, category, criteria);
  }
  function getAvailableValues(type, level, entityType, category, criteria, option) {
    var availableValues = getContextPropertyValue('availableValues', type, level, entityType, category, criteria);
    return availableValues && availableValues[option] ? availableValues[option] : undefined;
  }
  function getPattern(type, level, entityType, category, criteria, option) {
    var patterns = getContextPropertyValue('patterns', type, level, entityType, category, criteria);
    return patterns && patterns[option] ? patterns[option] : undefined;
  }
  function getContextValue(type, level, entityType, argsArray, property) {
    if (!level || _.some(argsArray, _.isNil)) {
      return null;
    }
    var context = getContext(type, level, entityType);
    return _.reduce(argsArray, function (scope, key) {
      if (scope) {
        return scope[key];
      }
    }, context[property]);
  }
  function getMetaCategory(type, level, entityType, category, criteria) {
    return getContextValue(type, level, entityType, [category, criteria], 'metaCategories');
  }
  function getField(type, level, entityType, category, criteria) {
    return getContextValue(type, level, entityType, [category, criteria], 'fields');
  }
  function getValueType(type, level, entityType, category, criteria, operator) {
    return getContextValue(type, level, entityType, [category, criteria, operator], 'categories');
  }
  function getPrecision(type, level, entityType, category, criteria, operator) {
    return getContextValue(type, level, entityType, [category, criteria, operator], 'precisions');
  }
  function getArgsNo(type, level, entityType, category, criteria, operator) {
    return getContextValue(type, level, entityType, [category, criteria, operator], 'argsNo');
  }
  function getConstraint(type, level, entityType, category, criteria) {
    return getContextValue(type, level, entityType, [category, criteria], 'constraints');
  }
  function getIsFieldValueRequired(type, level, entityType, category) {
    return getContextValue(type, level, entityType, [category], 'isFieldValueRequireds');
  }
  function hasVisibleCriteriaType(type, level, entityType, category, criteria) {
    var criteriaType = getContextValue(type, level, entityType, [category, criteria], 'criteriaType');
    return !!(criteriaType && criteriaType.userInputted);
  }
  function criteriaTypeRequired(context, category, criteria) {
    return context.criteriaType[category][criteria];
  }
  function criteriaTypeValuesMatch(criteriaType, field, fieldValue) {
    return criteriaType && field === criteriaType.fieldName && fieldValue === criteriaType.fieldValue;
  }
  function isCriteriaTypeCustomUserInput(criteriaType) {
    return criteriaType && criteriaType.userInputted;
  }
  function isCriteriaTypeMatch(context, category, criteria, criteriaType, field, fieldValue) {
    return !criteriaTypeRequired(context, category, criteria) || criteriaTypeValuesMatch(criteriaType, field, fieldValue) || isCriteriaTypeCustomUserInput(criteriaType);
  }
  function getCategoryCriteriaForField(type, level, entityType, flowType, field, fieldValue) {
    var result = [];
    var context = getContext(type, level, entityType, flowType);
    if (_.includes(field, '.daysOffsets(')) {
      var output = {
        category: 'Current Performance',
        criteria: 'Bookings Intake',
        criteriaType: null,
        metaCategory: null
      };
      result.push(output);
    }
    if (_.includes(field, '.daysOffsetsInPercent(')) {
      var outputInPercent = {
        category: 'Current Performance',
        criteria: 'Bookings Intake %',
        criteriaType: null,
        metaCategory: null
      };
      result.push(outputInPercent);
    }
    if (_.includes(field, '.lcaIndex(')) {
      var lcaIndex = {
        category: 'Availability',
        criteria: 'Lowest Class Open Index',
        criteriaType: null,
        metaCategory: null
      };
      result.push(lcaIndex);
    }
    _.forOwn(context.fields, function (criterions, category) {
      _.forOwn(criterions, function (f, criteria) {
        if (field === f || _.isArray(f) && _.includes(f, field)) {
          var criteriaType = context.criteriaType[category] ? context.criteriaType[category][criteria] : null;
          var output = {
            category: category,
            criteria: criteria,
            criteriaType: criteriaType,
            metaCategory: context.metaCategories[category][criteria]
          };
          if (isCriteriaTypeMatch(context, category, criteria, criteriaType, field, fieldValue)) {
            result.push(output);
            return false;
          }
        }
      });
    });
    if (result.length === 0) {
      throw new Error('Unknown field: "' + field + '" for level: "' + level + '"');
    }
    return result;
  }
  function getDefaultActionForLevel(type, level, entityType) {
    var result;
    var context = getContext(type, level, entityType);
    _.forOwn(context.fields, function (criterions, category) {
      _.forOwn(criterions, function (f, criteria) {
        result = {
          category: category,
          criterion: criteria,
          field: f,
          action: _.keys(context.categories[category][criteria])[0]
        };
        return false;
      });
    });
    return result;
  }
  function invalidateCache() {
    getContext.cache.clear();
  }
  return {
    getCategories: getCategories,
    getCriteria: getCriteria,
    getValueForCriteriaType: getValueForCriteriaType,
    getOperators: getOptions,
    getActions: getOptions,
    getValueType: getValueType,
    getPrecision: getPrecision,
    getConnectedFields: getConnectedFields,
    getAvailableValues: getAvailableValues,
    getPattern: getPattern,
    getField: getField,
    getMetaCategory: getMetaCategory,
    getConstraint: getConstraint,
    getCategoryCriteriaForField: getCategoryCriteriaForField,
    getArgsNo: getArgsNo,
    getIsFieldValueRequired: getIsFieldValueRequired,
    getDefaultActionForLevel: getDefaultActionForLevel,
    invalidateCache: invalidateCache,
    hasVisibleCriteriaType: hasVisibleCriteriaType
  };
};
StrategyRecordService.$inject = ['ConditionsAndActionsService', 'StrategyConstants'];
module.exports = StrategyRecordService;